import { render, staticRenderFns } from "./admin_ygfc.vue?vue&type=template&id=6e42348c&scoped=true"
import script from "./admin_ygfc.vue?vue&type=script&lang=js"
export * from "./admin_ygfc.vue?vue&type=script&lang=js"
import style0 from "./admin_ygfc.vue?vue&type=style&index=0&id=6e42348c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e42348c",
  null
  
)

export default component.exports